import React from 'react';
import { Translation } from 'react-i18next';

export function __(string, vars = {}) {
  return <Translation>{ (t) => {
    const text = t(string, {defaultValue: string, ...vars});

    return (text === '' || text === null) ? string : text;
  } }</Translation>
}